<script setup>
import { ref } from "vue";
import ResponsiveModal from "../Modals/ResponsiveModal.vue";
import { Link } from "@inertiajs/vue2";

// Props

const props = defineProps({
    lesson: {
        type: Object,
        required: true,
    },
    subMenuModal: {
        type: Boolean,
        default: false,
        required: false,
        description: "Use when the modal is a child",
    },
});

const emit = defineEmits(["reset", "refresh", "showMessage"]);

// Reactive State

const show = ref(true);

// Methods

function reset() {
    show.value = false;
    setTimeout(() => {
        emit("reset");
    }, 300);
}
</script>

<template>
    <ResponsiveModal
        v-if="show"
        title="Attendance"
        :subMenuModal="subMenuModal"
        @refresh="emit('refresh')"
        @reset="reset()"
    >
        <template #body>
            <v-list dense class="flex divide-y"
                ><v-list-item
                    two-line
                    v-for="(student, i) in lesson.students"
                    :key="student.id"
                    class="pr-0"
                    ><v-list-item-content
                        ><v-list-item-title
                            ><Link :href="`/profile/${student.id}/account`">{{
                                student.name
                            }}</Link></v-list-item-title
                        ><v-list-item-subtitle>{{
                            `${
                                student.attendance.is_guest
                                    ? student.attendance.purchase_option.name.includes(
                                          "First"
                                      )
                                        ? "First Visit"
                                        : student.attendance.purchase_option
                                              .category == "drop-ins"
                                        ? "Just Visiting"
                                        : "Rescheduled"
                                    : "Enrolled"
                            }`
                        }}</v-list-item-subtitle></v-list-item-content
                    >
                    <div class="flex shrink justify-end ma-0">
                        <SoliAttendance
                            v-if="lesson.id && lesson.type !== 'Hold'"
                            :eventId="lesson.id"
                            :event="lesson"
                            :studentId="student.id"
                            inline
                            :disabled="!!lesson.students[i].attendance.status"
                            :groupStatus="lesson.students[i].attendance.status"
                            @success="emit('showMessage', 300)"
                        ></SoliAttendance>
                    </div>
                </v-list-item>
            </v-list>
        </template>
    </ResponsiveModal>
</template>
